import { Component, EventEmitter, OnInit, Output, ViewChild, ElementRef } from '@angular/core';
import { AlertController, IonRouterOutlet } from '@ionic/angular';
import { ClientConfigService } from '../../services/client-config.service';
import { UIAppInitializationService } from '../../services/ui-app-initialization.service';
import { IVersion, SharedConfig, SharedDialogService, SharedEncryptionService } from '@takectrl-multiapp/svcs-share-config';
import '@lottiefiles/lottie-player';
import { SwUpdate } from '@angular/service-worker';
import { ApiCacheService } from 'libs/svcs-ctrl-api/src/lib/services/api-cache.service';
import { FirebaseService } from '@takectrl-multiapp/svcs-core';
import { Swiper } from 'swiper/types';
import { HttpClient } from '@angular/common/http';

declare const dataLayer: any[];

@Component({
  selector: 'landing',
  standalone: false,
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingComponent implements OnInit {
  @Output() navForgotPasswordPage: EventEmitter<unknown> = new EventEmitter<unknown>();
  @Output() navRegisterPage: EventEmitter<unknown> = new EventEmitter<unknown>();
  @Output() navLoginPage: EventEmitter<unknown> = new EventEmitter<unknown>();
  @Output() navigateTermsPage: EventEmitter<unknown> = new EventEmitter<unknown>();
  @ViewChild('slides') swiperSlide: ElementRef | undefined;
  swiper?: Swiper;
  @ViewChild('stepOne') stepOneVideo: ElementRef;
  @ViewChild('stepTwo') stepTwoVideo: ElementRef;
  @ViewChild('stepThree') stepThreeVideo: ElementRef;
  @ViewChild('stepFour') stepFourVideo: ElementRef;
  public clientDisplayName = this.sharedConfig.appClientDetail?.display_name;
  slideOpts = {
    slidesPerView: 1,
    loop: false,
  };
  public getCurrentSliderIndex = 0;
  public lottieSplash: boolean = false;
  hasSeenStepOne: boolean;
  hasSeenStepTwo: boolean;
  hasSeenStepThree: boolean;
  hasSeenStepFour: boolean;
  m_mode_popup = true;
  animationSrc: string = 'assets/lottie-animations/update.json';
  showDecomNotice: boolean = false;
  maintenancePeriodNotification: boolean = false;
  bottonWasClicked: string;
  constructor(
    public clientConfigService: ClientConfigService,
    public uiAppInitializationService: UIAppInitializationService,
    private readonly sharedEncryptionService: SharedEncryptionService,
    public sharedConfig: SharedConfig,
    public update: SwUpdate,
    private readonly routerOutlet: IonRouterOutlet,
    private readonly alertCtrl: AlertController,
    private readonly apiCacheService: ApiCacheService,
    public firebaseService: FirebaseService,
    private http: HttpClient,
    private readonly sharedDialogService: SharedDialogService
  ) {
    // registerSwiperElements();
  }

  ngAfterViewInit(): void {
    this.swiper = this.swiperSlide.nativeElement.swiper;
    console.log('page load')
    this.http.get('/assets/version.json' + '?noCache=' + new Date().getTime()).subscribe(data => {
      let new_version = (data as IVersion).version
      console.log('New Version - ' + new_version)
      console.log('Old Version - ' + this.sharedConfig.appVersion)
      if (this.sharedConfig.appVersion !== 'develop' && this.sharedConfig.appVersion !== new_version) {
        window.location.reload();
      }
    });
  }

  async ngOnInit(): Promise<void> {
    SharedConfig.clearSharedConfig();
    this.apiCacheService.clear();
    await this.firebaseService.signOut();

    this.lottieSplash = false;

    this.uiAppInitializationService.preUserValidationInitialization().then(() => {
      this.hasSeenStepOne = true;
      this.checkOTPLogin();
      this.routerOutlet.swipeGesture = false;
      this.startSplash();
    });

    dataLayer.push({
      event: 'page_show',
      screenPath: 'landing',
      screenName: 'landing',
      userUid: SharedConfig.firebaseUserKey ? SharedConfig.firebaseUserKey : 'NaN',
    });
  }

  startSplash() {
    this.stepTwoVideo.nativeElement.load();
    const intervalId = setInterval(() => {
      this.lottieSplash = false;
      this.stepOneVideo.nativeElement.play();
      clearInterval(intervalId);
    }, 1000);
  }

  async checkOTPLogin() {
    const urlParams = new URLSearchParams(window.location.search);
    SharedConfig.routeParamUserMsisdn = urlParams.get('msisdn');
    SharedConfig.routeParamUserFirstName = urlParams.get('firstName');
    SharedConfig.routeParamUserLastName = urlParams.get('surname');
    SharedConfig.routeParamUserEmail = urlParams.get('email');
    SharedConfig.routeParamUserEmailQuoteOnBehalf = urlParams.get('email_on_behalf');
    SharedConfig.routeParamUserPaswrd = urlParams.get('passwrd');
    SharedConfig.routeParamDealershipReferralCode = urlParams.get('ref');
    SharedConfig.routeParamBrokerCode = urlParams.get('broker');
    SharedConfig.routeParamLogInWithOTP = urlParams.get('OTPLogin');

    if (!SharedConfig.routeParamUserMsisdn) {
      SharedConfig.routeParamUserMsisdn = urlParams.get('e_msisdn')
        ? this.sharedEncryptionService.decryptStringECB(urlParams.get('e_msisdn'), SharedConfig.decryptionKey)
        : null;
    }

    if (!SharedConfig.routeParamUserFirstName) {
      SharedConfig.routeParamUserFirstName = urlParams.get('e_firstName')
        ? this.sharedEncryptionService.decryptStringECB(urlParams.get('e_firstName'), SharedConfig.decryptionKey)
        : null;
    }

    if (!SharedConfig.routeParamUserLastName) {
      SharedConfig.routeParamUserLastName = urlParams.get('e_surname')
        ? this.sharedEncryptionService.decryptStringECB(urlParams.get('e_surname'), SharedConfig.decryptionKey)
        : null;
    }

    if (!SharedConfig.routeParamUserEmail) {
      SharedConfig.routeParamUserEmail = urlParams.get('e_email')
        ? this.sharedEncryptionService.decryptStringECB(urlParams.get('e_email'), SharedConfig.decryptionKey)
        : null;
    }

    if (!SharedConfig.routeParamUserEmailQuoteOnBehalf) {
      SharedConfig.routeParamUserEmailQuoteOnBehalf = urlParams.get('e_email_on_behalf')
        ? this.sharedEncryptionService.decryptStringECB(urlParams.get('e_email_on_behalf'), SharedConfig.decryptionKey)
        : null;
    }

    if (!SharedConfig.routeParamUserPaswrd) {
      SharedConfig.routeParamUserPaswrd = urlParams.get('e_passwrd')
        ? this.sharedEncryptionService.decryptStringECB(urlParams.get('e_passwrd'), SharedConfig.decryptionKey)
        : null;
    }

    if (!SharedConfig.routeParamUserMsisdn && SharedConfig.routeParamDealershipReferralCode) {
      this.uiAppInitializationService.getAppSettings();
      return;
    }

    if (!SharedConfig.routeParamUserMsisdn && SharedConfig.routeParamBrokerCode) {
      this.uiAppInitializationService.getAppSettings();
      this.navRegisterPage.emit();
      return;
    }

    if (SharedConfig.routeParamUserEmail && !SharedConfig.routeParamUserMsisdn && !SharedConfig.routeParamUserEmailQuoteOnBehalf) {
      this.uiAppInitializationService.getAppSettings();
      this.navForgotPasswordPage.emit();
      return;
    }

    if (!SharedConfig.routeParamUserEmail) {
      const email = localStorage.getItem('userEmail');
      this.sharedConfig.setFirebaseUserEmail(email);
    }
    if (
      (SharedConfig.routeParamUserMsisdn || SharedConfig.routeParamLogInWithOTP || SharedConfig.routeParamUserEmailQuoteOnBehalf) &&
      this.sharedConfig.appSettings &&
      !this.sharedConfig.appSettings.maintenance_mode
    ) {
      this.navLoginPage.emit();
      return;
    }
  }

  closeUpdateAppPage() {
    SharedConfig.showPopupWithDismissButton_updateApp = false;
  }

  onEnded() {
    this.swiper = this.swiperSlide.nativeElement.swiper;
    if (this.hasSeenStepOne && !this.hasSeenStepTwo && !this.hasSeenStepThree && !this.hasSeenStepFour) {
      this.swiper?.slideTo(1);
      this.hasSeenStepOne = false;
      this.hasSeenStepTwo = true;
      this.hasSeenStepThree = false;
      this.hasSeenStepFour = false;
      this.stepTwoVideo.nativeElement.addEventListener(
        'loadeddata',
        function () {
          this.stepTwoVideo.nativeElement.play();
        },
        false
      );
    }
  }

  slideDidChange(e: any) {
    let index = this.swiper?.activeIndex
      this.getCurrentSliderIndex = index;
      if (index === 0) {
        this.stepFourVideo.nativeElement.currentTime = 0;
        this.stepOneVideo.nativeElement.play();
        this.hasSeenStepOne = true;
        this.hasSeenStepTwo = false;
        this.hasSeenStepThree = false;
        this.hasSeenStepFour = false;
        this.stepOneVideo.nativeElement.onended = () => {
          if (this.hasSeenStepOne && !this.hasSeenStepTwo && !this.hasSeenStepThree && !this.hasSeenStepFour) {
            this.swiper?.slideTo(1);
          }
        };
      }
      if (index === 1) {
        this.stepOneVideo.nativeElement.currentTime = 0;
        this.stepTwoVideo.nativeElement.play();
        this.hasSeenStepOne = false;
        this.hasSeenStepTwo = true;
        this.hasSeenStepThree = false;
        this.hasSeenStepFour = false;
        this.stepTwoVideo.nativeElement.onended = () => {
          if (!this.hasSeenStepOne && this.hasSeenStepTwo && !this.hasSeenStepThree && !this.hasSeenStepFour) {
            this.swiper?.slideTo(2);
          }
        };
      }
      if (index === 2) {
        this.stepTwoVideo.nativeElement.currentTime = 0;
        this.stepThreeVideo.nativeElement.play();
        this.hasSeenStepOne = false;
        this.hasSeenStepTwo = false;
        this.hasSeenStepThree = true;
        this.hasSeenStepFour = false;
        this.stepThreeVideo.nativeElement.onended = () => {
          if (!this.hasSeenStepOne && !this.hasSeenStepTwo && this.hasSeenStepThree && !this.hasSeenStepFour) {
            this.swiper?.slideTo(3);
          }
        };
      }
      if (index === 3) {
        this.stepThreeVideo.nativeElement.currentTime = 0;
        this.stepFourVideo.nativeElement.play();
        this.hasSeenStepOne = false;
        this.hasSeenStepTwo = false;
        this.hasSeenStepThree = false;
        this.hasSeenStepFour = true;
        this.stepFourVideo.nativeElement.onended = () => {
          if (!this.hasSeenStepOne && !this.hasSeenStepTwo && !this.hasSeenStepThree && this.hasSeenStepFour) {
            // this.swiper?.slideTo(0);
            this.swiper?.autoplay.stop();
          }
        };
      }
  }

  sliderAtEnd() {
    this.swiper?.autoplay.stop();
  }

  goToLastSlide() {
    this.swiper?.slideTo(6);
  }

  loginPage() {
    if (this.sharedConfig.appSettings.decommissioning_notice || this.sharedConfig.appSettings.maintenance_period_notification) {
      this.bottonWasClicked = 'login'
      this.showDecomNotice = this.sharedConfig.appSettings.decommissioning_notice;
      this.maintenancePeriodNotification = this.sharedConfig.appSettings.maintenance_period_notification;
    } else {
      this.navLoginPage.emit();
    }
  }

  async registerPage() {
    if (this.sharedConfig.appSettings.decommissioning_notice || this.sharedConfig.appSettings.maintenance_period_notification) {
      this.bottonWasClicked = 'register'
      this.showDecomNotice = this.sharedConfig.appSettings.decommissioning_notice;
      this.maintenancePeriodNotification = this.sharedConfig.appSettings.maintenance_period_notification;
    } else {
      this.navRegisterPage.emit();
    }
  }

  continueFromDecomNotice() {
    if (this.bottonWasClicked === 'login') {
      this.navLoginPage.emit();
      this.showDecomNotice = false;
    } else {
      this.showDecomNotice = false;
    }
  }

  closeMaintenancePeriodNotification() {
    if (this.sharedConfig.appSettings.decommissioning_notice) {
      this.maintenancePeriodNotification = false;
    } else {
      if (this.bottonWasClicked === 'login') {
        this.maintenancePeriodNotification = false;
        this.navLoginPage.emit();
      } else {
        this.maintenancePeriodNotification = false;
        this.navRegisterPage.emit();
      }
    }
  }

  termsPage() {
    window.open(this.sharedConfig.appSettings.terms_url, '_blank');
  }

  async showBypass() {
    const bypassAlert = await this.alertCtrl.create({
      header: 'Enter passcode',
      subHeader: 'Please enter your developer passcode.',
      inputs: [
        {
          name: 'passcode',
          placeholder: 'Enter Passcode',
          type: 'password',
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: 'Confirm',
          handler: (data) => {
            data.passcode;
            if (data.passcode === 'goldeneye') {
              this.m_mode_popup = false;
              bypassAlert.dismiss();
            }
          },
        },
      ],
    });
    bypassAlert.present();
  }
}
